import { render } from "./SinglePost.vue?vue&type=template&id=e219fbc4&scoped=true"
import script from "./SinglePost.vue?vue&type=script&lang=js"
export * from "./SinglePost.vue?vue&type=script&lang=js"

import "./SinglePost.vue?vue&type=style&index=0&id=e219fbc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e219fbc4"]])

export default __exports__